export default {
  terms:
    'Al realizar tu pedido, aceptas nuestros <TermsLink>Términos y condiciones</TermsLink> y nuestra <PrivacyPolicyLink>Política de privacidad</PrivacyPolicyLink>.',
};
